export enum AssetType {
  FIELD_ICON = "FIELD_ICON",
  OPTION_ICON = "OPTION_ICON",
  USER_INPUT = "USER_INPUT",
  PRIVATE_USER_INPUT = "PRIVATE_USER_INPUT",
  PROGRAM_HEADER_IMAGE = "PROGRAM_HEADER_IMAGE",
  PROGRAM_ICON = "PROGRAM_ICON",
  REIMBURSEMENT_RECEIPT = "REIMBURSEMENT_RECEIPT",
  ASSOCIATED_PROGRAM_ACTIVITY_IMAGE = "ASSOCIATED_PROGRAM_ACTIVITY_IMAGE",
  INVENTORY = "INVENTORY",
  CUSTOM_EVENT_ACTION_ICON = "CUSTOM_EVENT_ACTION_ICON"
}
